import React,{Component} from 'react';
import arrowIcon from '../../images/arrow.svg';

class AutoSSL extends Component{

    render(){
        return (
            <div className={`SSL-Selector__AutoSSL clearfix`}>
                <div className={`AutoSSL__heading`}>FREE AutoSSL</div>
                <div className={`AutoSSL__description`}>Free with VentraIP Australia Hosting Services.</div>
                <a className={`AutoSSL__hostingplan`} href={`https://ventraip.com.au/web-hosting/shared/`} target={`_blank`}>
                    <span className={`text`}>view web hosting plans</span>
                    <img className={`icon`} src={arrowIcon} alt={`Arrow Icon`} />
                </a>
            </div>
        )
    }
}

export default AutoSSL;